
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppDateTimePicker } from '@/components';
import { useProgressAdd } from '@/modules/progress/model/add';
import { ROUTE_NAME_PROGRESS } from '@/modules/progress/router';

export default defineComponent({
    name: ROUTE_NAME_PROGRESS.ITEM.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppDateTimePicker },
    setup() {
        const { model, v$, fetch, create } = useProgressAdd();

        onMounted(() => {
            fetch();
        });

        return { v$, model, create };
    }
});
